// Styled Component
import styled from 'styled-components';

//Dependencies
import { Link as RouterLink } from 'react-router-dom';

// Components
import { ButtonRight } from '../../../assets/icons/ButtonRight';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s} 0;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  padding-right: 1rem;
  align-items: center;

  svg > path {
    fill: ${({ theme }) => theme.colors.greyDark};
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding-right: ${({ theme }) => theme.spacing.xs};
  }
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  img {
    width: 1.6rem;
    height: 1.4rem;
  }
  p {
    margin-bottom: -0.2rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    img {
      width: 1.057rem;
      height: 0.925rem;
    }
  }
`;

/**
 * Hueco de una miga cuyo ROID aún no ha llegado. El ancho es el de un ROID
 * (`Ot.0000338.0000.01`) para que al entrar el texto la miga no se mueva; el
 * alto, el de una línea de `Typography` size S. El porqué, en `PendingCrumb`.
 */
export const PendingBar = styled.span`
  display: inline-block;
  width: 9.5rem;
  height: 1.2rem;
  border-radius: 0.3rem;
  background-color: ${({ theme }) => theme.colors.greyLight};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 6.3rem;
    height: 0.8rem;
  }
`;

export const RightButton = styled(ButtonRight)`
  width: 0.5rem;
  height: 0.9rem;
  margin-left: 1rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 0.33rem;
    height: 0.595rem;
    margin-left: 0.7rem;
  }
`;
